import React from "react";

function Profile() {
  return (
    <div id="description" class="basic-1">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div class="image-container">
              <img
                class="img-fluid"
                src="images/account.png"
                alt="alternative"
                style={{ height: 700 }}
              />
            </div>
          </div>
          <div class="col-lg-6">
            <div class="text-container">
              <h2>Create your accout account and enjoy the experience</h2>
              <p>
                There truly is something for everybody on SwipeRYT. Need to get
                into a relationship? It made perfect sense to you. Attempting to
                discover a few new companions? Say no more. New child nearby and
                hoping to take advantage of your school insight? SwipeRYT takes
                care of you. SwipeRYT isn't your normal dating site - it's the
                most different dating application, where grown-ups of all
                foundations and encounters are welcome to make associations,
                recollections, and everything in the middle.
              </p>
              <a
                class="btn-solid-reg popup-with-move-anim"
                href="#description-1-details-lightbox"
              >
                DOWNLOAD
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
